module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_iter-step.js
// module id = 171
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 15 16